
export type ReportRoadmap201 = {
  message?: string;
};
